import React from 'react'
import { Typography } from '@mui/material'

import { Icon } from '@components/Icon'

type FormHeaderProps = {
  data: {
    time: string
    duration: string
  }
}

export const TimeAndDuration = ({ data }: FormHeaderProps) => {
  const eventTime = data.time !== null ? data.time : ''
  const eventComma = data.time !== null && data.duration !== null ? ', ' : ''
  const eventDuration = data.duration !== null ? data.duration : ''

  const formattedTimeAndDuration = eventTime + eventComma + eventDuration
  if (formattedTimeAndDuration) {
    return (
      <>
        <Icon icon='clock' color='text.primary' sx={{ width: 16 }} />
        <Typography sx={{ ml: 1 }}>{formattedTimeAndDuration}</Typography>
      </>
    )
  }
  return null
}
